import { render, staticRenderFns } from "./WithRegisterModal.vue?vue&type=template&id=6fa2b0db&"
import script from "./WithRegisterModal.vue?vue&type=script&lang=js&"
export * from "./WithRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./WithRegisterModal.vue?vue&type=style&index=0&id=6fa2b0db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports